<template>
  <div class="course-detail">
    <div class="video-win">
      <video class="video-class" ref="videoRef" controls></video>
    </div>
    <div class="content-container">
      <div class="course-title">
        <div class="title">{{ detail.typeName }}</div>
        <div class="intro">{{ detail.intro }}</div>
      </div>
      <div class="hour-list">
        <div class="list-left">
          <div
            :class="['left-item', leftActive == index && 'left-item-active ']"
            v-for="(item, index) in detail.children"
            :key="item.id"
            @click="handleClickLeftItem(item, index)"
          >
            <div class="text-line-2">{{ item.typeName }}</div>
          </div>
        </div>
        <div class="list-right">
          <div
            class="right-item"
            v-for="(item, index) in hourList"
            :key="item.id"
            @click="handleClickRightItem(item, index)"
          >
            <div :class="['title', rightActive == index && 'title-active']">
              {{ item.name }}
            </div>
            <div class="time">{{ item.createTime.split(" ")[0] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wxSdk from "@/http/wxApi.js";
import { getMobilsInfo } from "@/utils";
import { clickRecord, queryLessonDetail, queryLessonHourList } from "@/http/api";

export default {
  name: "CourseDetail",
  data() {
    return {
      id: null,
      detail: {},
      hourList: [],
      leftActive: 0,
      rightActive: 0,
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getDetail();
    this.recordData();
  },
  methods: {
    async getDetail() {
      const { data } = await queryLessonDetail({
        id: this.id,
      });
      console.log(data);
      this.detail = data;
      this.wxShare();
      if (data.children.length) {
        this.getHourList(data.children[0].id);
      }
      document.title = data.typeName ? data.typeName : "花城+";
    },
    async getHourList(id) {
      const { data } = await queryLessonHourList({
        id,
      });
      this.hourList = data;
      if (this.hourList.length) {
        this.$refs.videoRef.poster = this.hourList[0].pictureUrl;
        this.$refs.videoRef.src = this.hourList[0].videoUrl;
      }
    },
    async recordData() {
      await clickRecord({
        deviceId: "1",
        operateId: this.id,
        operateType: 13,
        web:1,
      });
    },
    handleClickLeftItem(item, index) {
      if (this.leftActive == index) {
        return;
      }
      this.leftActive = index;
      this.rightActive = 0;
      this.getHourList(item.id);
    },
    handleClickRightItem(item, index) {
      if (this.rightActive == index) {
        return;
      }
      this.rightActive = index;
      this.$refs.videoRef.poster = item.pictureUrl;
      this.$refs.videoRef.src = item.videoUrl;
    },
    wxShare() {
      const _detail = this.detail;
      wxSdk.getJSSDK({
        title: _detail.typeName,
        desc: _detail.intro,
        linkurl: `${process.env.VUE_APP_SHARE_URL}/plusshare/#/courseDetail?id=${_detail.id}`,
        img: _detail.url,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
.course-detail {
  width: 100%;

  .video-win {
    width: 100%;
    height: 220px;
    background: #111;

    .video-class {
      width: 100%;
      height: 100%;
    }
  }

  .content-container {
    width: 100%;
    height: calc(100vh - 220px);
    overflow: hidden;

    .course-title {
      box-sizing: border-box;
      padding: 10px 10px 5px 10px;
      height: 60px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .title {
        color: #000000d9;
        font-weight: 500;
        font-size: 20px;
      }

      .intro {
        font-size: 14px;
      }
    }

    .hour-list {
      display: flex;
      width: 100%;
      height: calc(100vh - 280px);

      .list-left {
        width: 110px;
        height: 100%;

        .left-item {
          width: 100%;
          height: 70px;
          font-size: 14px;
          box-sizing: border-box;
          padding: 10px 13px;
          line-height: 24px;
          color: #000000a6;
        }

        .left-item-active {
          background: #eff0f8;
          border-radius: 4px;
        }
      }

      .list-right {
        width: 100%;
        flex: 1;
        height: 100%;
        overflow: hidden;
        overflow-y: auto;

        .right-item {
          width: 100%;
          height: 70px;
          box-sizing: border-box;
          padding: 10px 13px;
          border-bottom: 1px solid #eff0f8;

          .title {
            font-size: 16px;
            margin-bottom: 8px;
          }

          .title-active {
            color: #d55555;
          }

          .time {
            color: rgba(0, 0, 0, 0.45);
          }
        }
      }
    }
  }
}
</style>
